import { observable, action, makeObservable } from 'mobx';

class Menu {
    constructor() {
        makeObservable(this);
    }

    @observable state = {
        menus: [],
        activeMenu: {}
    };
    @action
    setState = (data) => {
        this.state = {
            ...this.state,
            ...data
        };
    };
    //找出所有叶子节点----用来注册路由
    getAllLeaf = (data) => {
        let result = [],
            getLeaf = (data) => {
                data.forEach((item) => {
                    if (item.children && item.children.length) {
                        getLeaf(item.children);
                    } else {
                        result.push(item);
                    }
                });
            };
        getLeaf(data);
        return result;
    };
    //考虑到不同layout下，菜单结构不同，所以在不同layout下去初始化菜单状态，而不是在app.js中
    changeMenuState = (pathname, menus) => {
        let res = {};
        let listMenus = this.getAllLeaf(menus);
        let index = listMenus.findIndex((ele) => ele.path === pathname);
        if (index !== -1) {
            res = listMenus[index];
        }
        this.setState({
            activeMenu: res
        });
    };
}
export default new Menu();
